module.exports = __webpack_public_path__ + "static/img/riverway.4dbcbb18.svg";